module.exports = __webpack_public_path__ + "img/logo-sd-cci.f69b84fd.png";